import * as React from 'react'

import { Icon, IconProps } from './Icon'

export const NorthIcon: React.FC<IconProps> = props => (
  <Icon fill="currentColor" {...props}>
    <path d="M5.71 9.69997C6.1 10.09 6.73 10.09 7.12 9.69997L11 5.82997V21C11 21.55 11.45 22 12 22C12.55 22 13 21.55 13 21V5.82997L16.88 9.70997C17.27 10.1 17.9 10.1 18.29 9.70997C18.68 9.31997 18.68 8.68997 18.29 8.29997L12.7 2.69997C12.31 2.30997 11.68 2.30997 11.29 2.69997L5.71 8.28997C5.32 8.67997 5.32 9.31997 5.71 9.69997Z" />
  </Icon>
)
